import ApiCall from "../constants/Api";
import SiteConfig from "../constants/SiteConfig";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useInsertFunctions = () => {
  //Call method InsertTrack
  const insertTrack = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.INSERT_TRACK,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method InsertTrackCategory
  const insertTrackCategory = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.INSERT_TRACK_CATEGORY,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method InsertTrackAltCategory
  const insertTrackAltCategory = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.INSERT_TRACK_ALT_CATEGORY,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method InsertTrackByBook
  const insertTracksByBook = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.INSERT_TRACKS_BY_BOOK,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method CopyTrackByBook
  const copyTracksByBook = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.COPY_TRACKS_BY_BOOK,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method CopyProfileTracks
  const copyTracksByProfile = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.COPY_TRACKS_BY_PROFILE,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method InsertProfileTracks
  const insertTracksByProfile = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.INSERT_TRACKS_BY_PROFILE,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method InsertLimitSet
  const insertLimitSet = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.INSERT_LIMIT_SET,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method CloneLimitSet
  const cloneLimitSet = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.CLONE_LIMIT_SET,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  //Call method savedefaultrace
  const insertDefaultRace = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_INTEGRATION_SVC,
        ApiCall.INSERT_DEFAULT_RACE,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };
  //Call method InsertLimitSetBetType
  const insertLimitSetBetType = async (request, LogonSessionID) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.INSERT_LIMIT_SET_BET_TYPE,
        {
          ...request,
        },
        LogonSessionID,
      );
      // Show error message
      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }
    return response;
  };

  return {
    insertTrack,
    insertTrackCategory,
    insertTrackAltCategory,
    insertTracksByBook,
    copyTracksByBook,
    copyTracksByProfile,
    insertTracksByProfile,
    insertLimitSet,
    cloneLimitSet,
    insertDefaultRace,
    insertLimitSetBetType,
  };
};
